// ----------------------------------------------------------------------------
// Snippet: Header menu
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

import './_header-menu.scss';

// -------------------------------------
// Variables
// -------------------------------------

// Selectors
var HEADER_SELECTOR = '.header';
var HEADER_SECTION_SELECTOR = '.section--header';
var HAMBURGER_SELECTOR = '.header__link--menu';
var HEADER_NAV_WRAPPER_SELECTOR = '.header__nav-wrapper';
var MENU_LIST_SELECTOR = '.header-menu__list';
var MENU_ITEM_SELECTOR = '.header-menu__item--dropdown';
var MOBILE_MENU_ITEM_SELECTOR = '.header-menu__list--mobile .header-menu__item--dropdown';
var OPEN_MENU_ITEM_SELECTOR = '.header-menu__item--dropdown.js--is-open';
var DESKTOP_TOP_MENU_ITEM_SELECTOR = '.header-menu__list--desktop .header-menu__item--level-1.header-menu__item--dropdown';
var DESKTOP_PANEL_SELECTOR = '.header-menu__item--panel';
var MENU_BUTTON_SELECTOR = '.header-menu__button';
var MOBILE_MENU_BUTTON_SELECTOR = '.header-menu__list--mobile .header-menu__button';
var DESKTOP_MENU_BUTTON_SELECTOR = '.header-menu__list--desktop .header-menu__button';
var MOBILE_MENU_LINK_SELECTOR = '.header-menu__list--mobile .header-menu__link';
var DESKTOP_MENU_LINK_SELECTOR = '.header-menu__list--desktop .header-menu__link';
var PANEL_LINK_SELECTOR = '.header-menu__panel-link';
var MENU_BACK_BUTTON_SELECTOR = '.header-menu__back .back__button';
var PANEL_ITEM_SELECTOR = '.header-menu__panel-item';
var PANEL_GROUP_SELECTOR = '.header-menu__panel-group';
var FOCUSABLE_SELECTOR = 'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';
var PANEL_BOTTOM_GAP = 16;

// Classes
var HEADER_NAV_WRAPPER_SLIDE_CLASS = 'mobile-slide';
var LEVEL_1_MENU_ITEM_CLASS = 'header-menu__item--level-1';
var MOBILE_MENU_LIST_CLASS = 'header-menu__list--mobile';
var MENU_BUTTON_CLASS = 'header-menu__button';
var MENU_BACK_BUTTON_CLASS = 'back__button';
var MENU_LINK_EMPTY_CLASS = 'header-menu__link--empty';
var OPEN_CLASS = 'js--is-open';
var ACTIVE_CLASS = 'is-active';
var DESKTOP_MENU_OPEN_CLASS = 'has-desktop-menu-open';
var NO_SCROLL_CLASS = 'noscroll';
var MENU_OPEN_LOCK_CLASS = 'has-menu-open';
var MOBILE_MEDIA_QUERY = '(max-width: 1023px)';

// Key codes
var INTERACTION_KEYS = [' ', 'Enter', 'Escape', 'Tab'];
var DESKTOP_ARROW_KEYS = ['ArrowDown', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'Home', 'End'];

// State
var desktopOutsideClickBound = false;

// -------------------------------------
// Helper functions
// -------------------------------------

function initMobileMenu() {
  var menu = {
    $body: document.querySelector('body'),
    $header: document.querySelector(HEADER_SELECTOR),
    $headerNavWrapper: document.querySelector(HEADER_NAV_WRAPPER_SELECTOR),
    $hamburger: document.querySelector(HAMBURGER_SELECTOR),
    $items: document.querySelectorAll(MOBILE_MENU_ITEM_SELECTOR),
    $buttons: document.querySelectorAll(MOBILE_MENU_BUTTON_SELECTOR),
    $links: document.querySelectorAll(MOBILE_MENU_LINK_SELECTOR)
  };
  initMenuButtons(menu, 'mobile');
  initMenuLinks(menu, 'mobile');
}
function initDesktopMenu() {
  var menu = {
    $topLevelItems: document.querySelectorAll(DESKTOP_TOP_MENU_ITEM_SELECTOR),
    $buttons: document.querySelectorAll(DESKTOP_MENU_BUTTON_SELECTOR),
    $links: document.querySelectorAll(DESKTOP_MENU_LINK_SELECTOR)
  };
  initDesktopTopLevelItems(menu.$topLevelItems);
  initDesktopPanels();
  initMenuButtons(menu, 'desktop');
  initMenuLinks(menu, 'desktop');

  // Close an open desktop (mega) dropdown when clicking outside it. Bound once
  // on the document; safe to leave bound on mobile since it only acts on open
  // desktop top-level dropdowns (none exist while the desktop list is hidden).
  if (!desktopOutsideClickBound) {
    document.addEventListener('click', handleDesktopOutsideClick);
    desktopOutsideClickBound = true;
  }
}

// Closes any open desktop mega dropdown when a click lands outside its trigger
// and panel. The menu's own buttons/links call stopPropagation, so they never
// reach here; clicks inside the panel (a descendant of the trigger) are ignored
// via `item.contains`; and the dim overlay is pointer-events:none, so clicking
// the dimmed page counts as "outside" and closes the menu.
// True if the click landed on the trigger or within the *visible* part of the
// open dropdown. The full-bleed panel spans 100vw and always renders three
// 300px columns, but level-2/3 are blank until a category is hovered — so a
// click in those blank columns (or the empty space beside the panel) must count
// as "outside". We test the click point against the rects of only the pieces
// that are actually visible right now.
function isClickInsideVisibleDropdown(item, event) {
  var x = event.clientX;
  var y = event.clientY;
  var parts = [];
  var link = getDirectChild(item, '.header-menu__link');
  var button = getDirectChild(item, MENU_BUTTON_SELECTOR);
  if (link) parts.push(link);
  if (button) parts.push(button);

  // Panel: level-1 is always visible; level-2/3 only once populated/active.
  item.querySelectorAll('.header-menu__panel-column--level-1').forEach(function (column) {
    parts.push(column);
  });
  item.querySelectorAll('.header-menu__panel-column--level-2, .header-menu__panel-column--level-3').forEach(function (column) {
    if (column.querySelector('.header-menu__panel-group.is-active')) {
      parts.push(column);
    }
  });

  // Simple and columns dropdowns fill their own box, so the whole thing counts.
  item.querySelectorAll('.header-menu__list--simple, .header-menu_columns').forEach(function (content) {
    parts.push(content);
  });
  return parts.some(function (el) {
    var rect = el.getBoundingClientRect();
    return x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;
  });
}
function handleDesktopOutsideClick(event) {
  var openItems = document.querySelectorAll("".concat(DESKTOP_TOP_MENU_ITEM_SELECTOR, ".").concat(OPEN_CLASS));
  if (openItems.length === 0) {
    return;
  }
  openItems.forEach(function (item) {
    if (isClickInsideVisibleDropdown(item, event)) {
      return;
    }
    closeDropdown(item, getDirectChild(item, MENU_BUTTON_SELECTOR));
  });
}
function initDesktopPanels() {
  var desktopPanels = document.querySelectorAll(DESKTOP_PANEL_SELECTOR);
  desktopPanels.forEach(function (panel) {
    if (panel.dataset.panelInit === 'true') {
      return;
    }
    panel.dataset.panelInit = 'true';
    var panelItems = panel.querySelectorAll(PANEL_ITEM_SELECTOR);
    panelItems.forEach(function (item) {
      item.addEventListener('mouseenter', handleDesktopPanelInteraction);
      item.addEventListener('focusin', handleDesktopPanelInteraction);
    });
    var panelLinks = panel.querySelectorAll(PANEL_LINK_SELECTOR);
    panelLinks.forEach(function (link) {
      if (link.dataset.menuInit === 'true') {
        return;
      }
      link.dataset.menuInit = 'true';
      link.source = 'desktop';
      link.menuType = 'panel-link';
      link.addEventListener('keydown', handleKeydown);
    });
  });
}
function initMenuButtons(menu, source) {
  menu.$buttons.forEach(function (button) {
    if (button.dataset.menuInit === 'true') {
      return;
    }
    button.dataset.menuInit = 'true';
    button.menu = menu;
    button.source = source;
    button.menuType = 'button';
    button.addEventListener('click', handleClick);
    button.addEventListener('keydown', handleKeydown);
  });

  // If we're on mobile and using the slide layout, initialize back buttons
  if (source === 'mobile' && menu.$headerNavWrapper.classList.contains(HEADER_NAV_WRAPPER_SLIDE_CLASS)) {
    var backButtons = document.querySelectorAll(MENU_BACK_BUTTON_SELECTOR);
    backButtons.forEach(function (button) {
      if (button.dataset.menuInit === 'true') {
        return;
      }
      button.dataset.menuInit = 'true';
      button.menu = menu;
      button.source = source;
      button.menuType = 'back-button';
      button.addEventListener('click', handleClick);
      button.addEventListener('keydown', handleKeydown);
    });
  }
}
function initMenuLinks(menu, source) {
  menu.$links.forEach(function (link) {
    if (link.dataset.menuInit === 'true') {
      return;
    }
    link.dataset.menuInit = 'true';
    link.menu = menu;
    link.source = source;
    link.menuType = 'link';
    link.addEventListener('click', handleClick);
    link.addEventListener('keydown', handleKeydown);
    link.addEventListener('focus', handleFocus);
  });
}
function initDesktopTopLevelItems(topLevelItems) {
  topLevelItems.forEach(function (item) {
    if (item.dataset.desktopMenuInit === 'true') {
      return;
    }
    item.dataset.desktopMenuInit = 'true';
    item.addEventListener('mouseenter', handleHover);
    item.addEventListener('mouseleave', handleHover);
    item.addEventListener('focusin', handleDesktopFocusIn);
    item.addEventListener('focusout', handleDesktopFocusOut);
  });
}
function handleClick(event) {
  var $this = event.currentTarget;
  event.stopPropagation();
  if ($this.menuType === 'button') {
    handleMenuButtonInteraction($this, event);
  } else if ($this.menuType === 'back-button') {
    handleBackButtonInteraction($this, event);
  } else {
    handleMenuLinkInteraction($this, event);
  }
}
function handleKeydown(event) {
  event.stopPropagation();
  handleKeyboardInteraction(event.currentTarget, event);
}
function handleFocus(event) {
  var link = event.currentTarget;
  var parentItem = link.parentElement;
  if (!parentItem || !parentItem.classList.contains(LEVEL_1_MENU_ITEM_CLASS)) {
    return;
  }
  if (link.source === 'desktop' && parentItem.classList.contains('header-menu__item--dropdown')) {
    return;
  }
  if (link.menu.$topLevelItems) {
    closeSiblingDesktopDropdowns(parentItem);
  }
}
function handleHover(event) {
  var $this = event.currentTarget;
  var button = $this.querySelector(MENU_BUTTON_SELECTOR);
  if (event.type === 'mouseenter') {
    setTimeout(openDropdown($this, button), 80);
  } else {
    setTimeout(closeDropdown($this, button), 80);
  }
}
function handleDesktopFocusIn(event) {
  var item = event.currentTarget;
  var button = item.querySelector(MENU_BUTTON_SELECTOR);
  openDesktopDropdownItem(item, button);
}
function handleDesktopFocusOut(event) {
  var item = event.currentTarget;
  var nextFocusedElement = event.relatedTarget;
  if (nextFocusedElement !== null && item.contains(nextFocusedElement)) {
    return;
  }
  var button = item.querySelector(MENU_BUTTON_SELECTOR);
  closeDropdown(item, button);
}
function handleDesktopPanelInteraction(event) {
  var panelItem = event.currentTarget;
  var panel = panelItem.closest(DESKTOP_PANEL_SELECTOR);
  if (panel === null) {
    return;
  }
  activateDesktopPanelItem(panel, panelItem);
}
function handleMenuButtonInteraction(button, event) {
  event.preventDefault();
  var parentItem = button.closest(MENU_ITEM_SELECTOR);
  if (parentItem.classList.contains(OPEN_CLASS)) {
    closeDropdown(parentItem, button);
  } else {
    if (button.source === 'desktop' && parentItem.matches(DESKTOP_PANEL_SELECTOR)) {
      resetDesktopPanelState(parentItem);
    }
    openDropdown(parentItem, button);

    // If we're using the slide layout and the button is top level, move focus to child
    // panel back button
    if (button.source === 'mobile') {
      if (button.menu.$headerNavWrapper.classList.contains(HEADER_NAV_WRAPPER_SLIDE_CLASS)) {
        var childList = getDirectChild(parentItem, MENU_LIST_SELECTOR);
        if (childList !== null) {
          var backButton = childList.querySelector(MENU_BACK_BUTTON_SELECTOR);

          // Delay setting the focus so that there's time for it to become visible
          if (backButton !== null) {
            setTimeout(function () {
              backButton.focus();
            }, 30);
          }
        }
      }
    }
  }
}
function openDesktopDropdownItem(item, button) {
  closeSiblingDesktopDropdowns(item);
  openDropdown(item, button);
}
function moveDesktopTopLevelFocus(currentItem, direction) {
  var topLevelItems = Array.from(document.querySelectorAll(DESKTOP_TOP_MENU_ITEM_SELECTOR));
  var currentIndex = topLevelItems.indexOf(currentItem);
  if (currentIndex === -1) {
    return;
  }
  var nextIndex = (currentIndex + direction + topLevelItems.length) % topLevelItems.length;
  focusDesktopTopLevelItem(topLevelItems[nextIndex]);
}
function handleBackButtonInteraction(button, event) {
  if (event) {
    event.preventDefault();
  }
  var parentItem = button.closest(MENU_ITEM_SELECTOR);
  if (parentItem === null) {
    return;
  }
  var parentButton = getDirectChild(parentItem, MENU_BUTTON_SELECTOR);
  closeDropdown(parentItem, parentButton);
  if (parentButton !== null) {
    parentButton.focus();
  }
}
function handleMenuLinkInteraction(link, event) {
  var href = link.getAttribute('href');
  var path = window.location.pathname;
  var isCurrentLink = href === path;
  var isCurrentLinkOrAnchor = false;
  if (link.classList.contains(MENU_LINK_EMPTY_CLASS) || isCurrentLink) {
    isCurrentLinkOrAnchor = true;
  }
  if (isCurrentLinkOrAnchor) {
    event.preventDefault();
    if (link.source === 'mobile') {
      closeMenu(link.menu);
    } else {
      var topLevelItem = link.closest(DESKTOP_TOP_MENU_ITEM_SELECTOR);
      var button = topLevelItem.querySelector(MENU_BUTTON_SELECTOR);
      closeDropdown(topLevelItem, button);
    }
  } else {
    if (event.key === ' ') {
      event.preventDefault();
      window.location.assign(href);
    }
  }
}
function handleKeyboardInteraction(element, event) {
  var key = event.key;
  if (element.source === 'desktop' && DESKTOP_ARROW_KEYS.includes(key)) {
    if (handleDesktopArrowNavigation(element, key, event)) {
      return;
    }
  }
  if (INTERACTION_KEYS.includes(key)) {
    if (key === ' ' || key === 'Enter') {
      // If the current element is a button, toggle the dropdown
      // If it's a back button, close the current dropdown and move focus back to the parent
      // Otherwise, it's a link
      if (element.classList.contains(MENU_BUTTON_CLASS)) {
        handleMenuButtonInteraction(element, event);
      } else if (element.classList.contains(MENU_BACK_BUTTON_CLASS)) {
        handleBackButtonInteraction(element, event);
      } else if (key === 'Enter') {
        handleMenuLinkInteraction(element, event);
      }
    } else if (key === 'Escape') {
      // Find the closest parent dropdown, close it, and focus the associated button
      if (element.source === 'mobile') {
        var closestOpenDropdown;
        if (element.classList.contains(MENU_BUTTON_CLASS) || element.classList.contains(MENU_BACK_BUTTON_CLASS)) {
          closestOpenDropdown = element.closest(OPEN_MENU_ITEM_SELECTOR);
        } else {
          closestOpenDropdown = element.closest(MENU_ITEM_SELECTOR);
        }
        if (closestOpenDropdown !== null) {
          var button = closestOpenDropdown.querySelector(MENU_BUTTON_SELECTOR);
          closeDropdown(closestOpenDropdown, button);
          button.focus();
        } else {
          closeMenu(element.menu);
        }
      } else {
        var topLevelItem = element.closest(DESKTOP_TOP_MENU_ITEM_SELECTOR);
        var _button = topLevelItem.querySelector(MENU_BUTTON_SELECTOR);
        closeDropdown(topLevelItem, _button);
        _button.focus();
      }
    } else if (key === 'Tab') {
      // If we're on mobile, using the slide layout, and inside a level 2 menu, keep tab focus
      // from leaving the menu
      if (element.source === 'mobile') {
        if (element.menu.$headerNavWrapper.classList.contains(HEADER_NAV_WRAPPER_SLIDE_CLASS)) {
          var parentList = element.closest(MENU_LIST_SELECTOR);
          if (isSlidePanel(parentList)) {
            var $this = event.target;
            var focusableElements = getFocusableElements(parentList);
            var firstFocusableElement = focusableElements[0];
            var lastFocusableElement = focusableElements[focusableElements.length - 1];
            if (focusableElements.length === 0) {
              return;
            }
            if (event.shiftKey) {
              if ($this === firstFocusableElement) {
                event.preventDefault();
                lastFocusableElement.focus();
              }
            } else if ($this === lastFocusableElement) {
              event.preventDefault();
              firstFocusableElement.focus();
            }
          }
        }
      }
    }
  }
}
function handleDesktopArrowNavigation(element, key, event) {
  if (element.classList.contains('header-menu__panel-link')) {
    return handleDesktopPanelArrowNavigation(element, key, event);
  }
  var topLevelItem = element.closest(DESKTOP_TOP_MENU_ITEM_SELECTOR);
  if (topLevelItem === null) {
    return false;
  }
  var parentList = element.closest(MENU_LIST_SELECTOR);
  if (parentList !== null && parentList.classList.contains('header-menu__list--simple')) {
    return handleDesktopSimpleDropdownArrowNavigation(element, key, event);
  }
  return handleDesktopTopLevelArrowNavigation(topLevelItem, key, event);
}
function handleDesktopTopLevelArrowNavigation(item, key, event) {
  var topLevelItems = Array.from(document.querySelectorAll(DESKTOP_TOP_MENU_ITEM_SELECTOR));
  var currentIndex = topLevelItems.indexOf(item);
  if (currentIndex === -1) {
    return false;
  }
  if (key === 'ArrowRight') {
    event.preventDefault();
    focusDesktopTopLevelItem(topLevelItems[(currentIndex + 1) % topLevelItems.length]);
    return true;
  }
  if (key === 'ArrowLeft') {
    event.preventDefault();
    focusDesktopTopLevelItem(topLevelItems[(currentIndex - 1 + topLevelItems.length) % topLevelItems.length]);
    return true;
  }
  if (key === 'Home') {
    event.preventDefault();
    focusDesktopTopLevelItem(topLevelItems[0]);
    return true;
  }
  if (key === 'End') {
    event.preventDefault();
    focusDesktopTopLevelItem(topLevelItems[topLevelItems.length - 1]);
    return true;
  }
  if ((key === 'ArrowDown' || key === 'ArrowUp') && item.classList.contains('header-menu__item--dropdown')) {
    event.preventDefault();
    var button = getDirectChild(item, MENU_BUTTON_SELECTOR);
    var focusTarget = key === 'ArrowDown' ? getFirstDesktopSubmenuFocusable(item) : getLastDesktopSubmenuFocusable(item);
    openDesktopDropdownItem(item, button);
    if (focusTarget !== null) {
      focusTarget.focus();
    }
    return true;
  }
  return false;
}
function handleDesktopSimpleDropdownArrowNavigation(element, key, event) {
  var list = element.closest('.header-menu__list--simple');
  if (list === null) {
    return false;
  }
  var focusableLinks = Array.from(list.querySelectorAll('.header-menu__link'));
  var currentIndex = focusableLinks.indexOf(element);
  if (currentIndex === -1) {
    return false;
  }
  if (key === 'ArrowDown') {
    event.preventDefault();
    focusableLinks[(currentIndex + 1) % focusableLinks.length].focus();
    return true;
  }
  if (key === 'ArrowUp') {
    event.preventDefault();
    focusableLinks[(currentIndex - 1 + focusableLinks.length) % focusableLinks.length].focus();
    return true;
  }
  if (key === 'Home') {
    event.preventDefault();
    focusableLinks[0].focus();
    return true;
  }
  if (key === 'End') {
    event.preventDefault();
    focusableLinks[focusableLinks.length - 1].focus();
    return true;
  }
  if (key === 'ArrowRight' || key === 'ArrowLeft') {
    event.preventDefault();
    var topLevelItem = element.closest(DESKTOP_TOP_MENU_ITEM_SELECTOR);
    if (topLevelItem === null) {
      return true;
    }
    moveDesktopTopLevelFocus(topLevelItem, key === 'ArrowRight' ? 1 : -1);
    return true;
  }
  return false;
}
function handleDesktopPanelArrowNavigation(link, key, event) {
  var panel = link.closest(DESKTOP_PANEL_SELECTOR);
  var currentItem = link.closest(PANEL_ITEM_SELECTOR);
  var currentList = link.closest('.header-menu__panel-list');
  if (panel === null || currentItem === null || currentList === null) {
    return false;
  }
  var panelLinks = Array.from(currentList.querySelectorAll(PANEL_LINK_SELECTOR));
  var currentIndex = panelLinks.indexOf(link);
  if (currentIndex === -1) {
    return false;
  }
  if (key === 'ArrowDown') {
    event.preventDefault();
    panelLinks[(currentIndex + 1) % panelLinks.length].focus();
    return true;
  }
  if (key === 'ArrowUp') {
    event.preventDefault();
    panelLinks[(currentIndex - 1 + panelLinks.length) % panelLinks.length].focus();
    return true;
  }
  if (key === 'Home') {
    event.preventDefault();
    panelLinks[0].focus();
    return true;
  }
  if (key === 'End') {
    event.preventDefault();
    panelLinks[panelLinks.length - 1].focus();
    return true;
  }
  if (key === 'ArrowRight') {
    var targetGroup = getDesktopPanelTargetGroup(panel, currentItem);
    if (targetGroup === null) {
      return false;
    }
    event.preventDefault();
    activateDesktopPanelItem(panel, currentItem);
    var targetLink = targetGroup.querySelector(PANEL_LINK_SELECTOR);
    if (targetLink !== null) {
      targetLink.focus();
    }
    return true;
  }
  if (key === 'ArrowLeft') {
    var currentGroup = link.closest(PANEL_GROUP_SELECTOR);
    if (currentGroup === null) {
      return false;
    }
    var parentTriggerItem = panel.querySelector("".concat(PANEL_ITEM_SELECTOR, "[data-panel-target=\"").concat(currentGroup.dataset.panelGroup, "\"]"));
    if (parentTriggerItem === null) {
      return false;
    }
    event.preventDefault();
    var parentLink = parentTriggerItem.querySelector(PANEL_LINK_SELECTOR);
    if (parentLink !== null) {
      parentLink.focus();
    }
    return true;
  }
  return false;
}
function closeMenu(menu) {
  menu.$body.classList.remove(NO_SCROLL_CLASS);
  menu.$header.classList.remove(OPEN_CLASS);
  menu.$hamburger.classList.remove(OPEN_CLASS);
  removeClassFromElements(menu.$items, OPEN_CLASS);
  setAttributeForElements(menu.$buttons, 'aria-expanded', 'false');
  updateDesktopMenuOverlay();
}
function closeSiblingDesktopDropdowns(currentItem) {
  var topLevelItems = document.querySelectorAll(DESKTOP_TOP_MENU_ITEM_SELECTOR);
  topLevelItems.forEach(function (item) {
    if (item === currentItem) {
      return;
    }
    var childButton = item.querySelector(MENU_BUTTON_SELECTOR);
    closeDropdown(item, childButton);
  });
}
function syncDesktopDropdownHeight(item) {
  var dropdown = getDirectChild(item, MENU_LIST_SELECTOR);
  if (dropdown === null) {
    return;
  }
  var top = dropdown.getBoundingClientRect().top;
  var available = Math.max(Math.floor(window.innerHeight - top - PANEL_BOTTOM_GAP), 0);
  item.style.setProperty('--header-panel-max-height', "".concat(available, "px"));
}
function openDropdown(item, button) {
  item.classList.add(OPEN_CLASS);
  if (button) {
    button.setAttribute('aria-expanded', 'true');
  }
  if (item.matches(DESKTOP_TOP_MENU_ITEM_SELECTOR)) {
    syncDesktopDropdownHeight(item);
  }
  updateDesktopMenuOverlay();
}
function closeDropdown(item, button) {
  item.classList.remove(OPEN_CLASS);
  if (button) {
    button.setAttribute('aria-expanded', 'false');
  }
  if (item.matches(DESKTOP_PANEL_SELECTOR)) {
    resetDesktopPanelState(item);
  }
  var childList = getDirectChild(item, MENU_LIST_SELECTOR);
  if (childList) {
    var childListDropdownItems = childList.querySelectorAll(MENU_ITEM_SELECTOR);
    childListDropdownItems.forEach(function (childItem) {
      var childButton = getDirectChild(childItem, MENU_BUTTON_SELECTOR);
      childItem.classList.remove(OPEN_CLASS);
      if (childButton) {
        childButton.setAttribute('aria-expanded', 'false');
      }
    });
  }
  updateDesktopMenuOverlay();
}
function activateDesktopPanelItem(panel, item) {
  var level = item.dataset.panelTrigger;
  var target = item.dataset.panelTarget || '';
  var panelList = item.closest('.header-menu__panel-list');
  if (panelList !== null) {
    panelList.querySelectorAll(PANEL_ITEM_SELECTOR).forEach(function (panelItem) {
      panelItem.classList.remove(ACTIVE_CLASS);
    });
  }
  item.classList.add(ACTIVE_CLASS);
  if (level === 'level-1') {
    if (target === '') {
      clearDesktopPanelGroups(panel, '.header-menu__panel-group--level-2');
      clearDesktopPanelGroups(panel, '.header-menu__panel-group--level-3');
      return;
    }
    setDesktopPanelGroup(panel, target);
    clearDesktopPanelGroups(panel, '.header-menu__panel-group--level-3');
  } else if (level === 'level-2') {
    if (target !== '') {
      setDesktopPanelGroup(panel, target);
    } else {
      clearDesktopPanelGroups(panel, '.header-menu__panel-group--level-3');
    }
  }
}
function getDesktopPanelTargetGroup(panel, item) {
  var target = item.dataset.panelTarget || '';
  if (target === '') {
    return null;
  }
  return panel.querySelector("".concat(PANEL_GROUP_SELECTOR, "[data-panel-group=\"").concat(target, "\"]"));
}
function setDesktopPanelGroup(panel, target) {
  if (target === '') {
    return null;
  }
  var targetGroup = panel.querySelector("".concat(PANEL_GROUP_SELECTOR, "[data-panel-group=\"").concat(target, "\"]"));
  if (targetGroup === null) {
    return null;
  }
  var groupClass = Array.from(targetGroup.classList).find(function (className) {
    return className.indexOf('header-menu__panel-group--level-') === 0;
  });
  if (groupClass) {
    clearDesktopPanelGroups(panel, ".".concat(groupClass));
  }
  targetGroup.classList.add(ACTIVE_CLASS);
  return targetGroup;
}
function clearDesktopPanelGroups(panel, selector) {
  panel.querySelectorAll(selector).forEach(function (group) {
    group.classList.remove(ACTIVE_CLASS);
  });
}
function resetDesktopPanelState(panel) {
  panel.querySelectorAll(PANEL_ITEM_SELECTOR).forEach(function (item) {
    item.classList.remove(ACTIVE_CLASS);
  });
  clearDesktopPanelGroups(panel, '.header-menu__panel-group--level-2');
  clearDesktopPanelGroups(panel, '.header-menu__panel-group--level-3');
}
function getDirectChild(parent, selector) {
  if (parent === null) {
    return null;
  }
  return Array.from(parent.children).find(function (child) {
    return child.matches(selector);
  }) || null;
}
function getFirstDesktopSubmenuFocusable(item) {
  if (item.matches(DESKTOP_PANEL_SELECTOR)) {
    return item.querySelector('.header-menu__panel-column--level-1 .header-menu__panel-link');
  }
  return item.querySelector('.header-menu__list--level-2 .header-menu__link');
}
function getLastDesktopSubmenuFocusable(item) {
  if (item.matches(DESKTOP_PANEL_SELECTOR)) {
    var _links = item.querySelectorAll('.header-menu__panel-column--level-1 .header-menu__panel-link');
    return _links.length > 0 ? _links[_links.length - 1] : null;
  }
  var links = item.querySelectorAll('.header-menu__list--level-2 .header-menu__link');
  return links.length > 0 ? links[links.length - 1] : null;
}
function focusDesktopTopLevelItem(item) {
  if (item === null) {
    return;
  }
  var focusTarget = getDirectChild(item, '.header-menu__link') || getDirectChild(item, MENU_BUTTON_SELECTOR);
  if (focusTarget !== null) {
    focusTarget.focus();
  }
}
function isSlidePanel(list) {
  return list !== null && !list.classList.contains(MOBILE_MENU_LIST_CLASS);
}
function getFocusableElements(container) {
  if (container === null) {
    return [];
  }
  return Array.from(container.querySelectorAll(FOCUSABLE_SELECTOR)).filter(function (element) {
    var style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden';
  });
}
function updateDesktopMenuOverlay() {
  var headerSection = document.querySelector(HEADER_SECTION_SELECTOR);
  if (headerSection === null) {
    return;
  }
  var hasOpenDesktopMenu = headerSection.querySelector("".concat(DESKTOP_TOP_MENU_ITEM_SELECTOR, ".").concat(OPEN_CLASS)) !== null;
  headerSection.classList.toggle(DESKTOP_MENU_OPEN_CLASS, hasOpenDesktopMenu);
  if (!window.matchMedia(MOBILE_MEDIA_QUERY).matches) {
    document.documentElement.classList.toggle(MENU_OPEN_LOCK_CLASS, hasOpenDesktopMenu);
  }
}
function removeClassFromElements(elems, className) {
  elems.forEach(function (elem) {
    elem.classList.remove(className);
  });
}
function setAttributeForElements(elems, attribute, value) {
  elems.forEach(function (elem) {
    elem.setAttribute(attribute, value);
  });
}

// -------------------------------------
// Hooks
// -------------------------------------

document.addEventListener('DOMContentLoaded', function () {
  var mobileMedia = window.matchMedia('(max-width: 1023px)');
  if (mobileMedia.matches) {
    initMobileMenu();
  } else {
    initDesktopMenu();
  }
});
window.addEventListener('resize', function () {
  var mobileMedia = window.matchMedia('(max-width: 1023px)');
  if (mobileMedia.matches) {
    initMobileMenu();
  } else {
    initDesktopMenu();
  }
});